import { useEffect } from "react";
import action from "../utils/qiankun/action";

const MicroNode = ({
  useTips,
  // isVIP,
  handleCardClick,
  logInfo,
  subscriptionsInfo,
  handleOpenSub,
  handleOpenPre,
  handleOpenLogin,
  handleOpenFeedback,
}) => {
  useEffect(() => {
    action.setGlobalState({
      handleCardClick: (uuid: number) => handleCardClick(uuid),
      logInfo: logInfo,
      subscriptionsInfo: subscriptionsInfo,
      useTips: useTips,
      handleOpenSub: (value: boolean) => handleOpenSub(value),
      handleOpenPre: (value: boolean) => handleOpenPre(value),
      handleOpenLogin: (value: boolean) => handleOpenLogin(value),
      handleOpenFeedback:(value:boolean) => handleOpenFeedback(value),
    });
  }, [handleCardClick, logInfo, subscriptionsInfo, handleOpenLogin, handleOpenSub, handleOpenPre, handleOpenFeedback]);

  // if (!isVIP) {
  //   return null
  // }

  return (
    <div id="ominicraft-root"></div>
  );
};

export default MicroNode;
